<!-- ══ Give Feedback dialog — Business Partner form pattern (header strip, logo badge,
     icon section labels, toggle rows), theme tokens only ══ -->
<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [showHeader]="false"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '31rem', 'max-width': '94vw' }"
  styleClass="afb-dialog"
>
  <div class="afb-header">
    <div class="afb-header-left">
      <div class="afb-logo-badge"><i class="pi pi-star"></i></div>
      <div>
        <h2 class="afb-title">{{ 'appFeedback.title' | t }}</h2>
        <p class="afb-subtitle">{{ 'appFeedback.subtitle' | t }}</p>
      </div>
    </div>
    <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-rounded afb-close-btn"
      (click)="close()" aria-label="Close"></button>
  </div>

  <!-- Step 1: rating -->
  <div class="afb-body afb-step" *ngIf="step === 'rate'">
    <div class="afb-section-label"><i class="pi pi-heart"></i>{{ 'appFeedback.question' | t }}</div>
    <div class="afb-rate-grid">
      <button type="button" class="afb-rate-tile" *ngFor="let r of ratings; let i = index"
        [style.animation-delay]="(i * 60) + 'ms'" (click)="pickRating(r.value)">
        <span class="afb-rate-emoji">{{ r.emoji }}</span>
        <span class="afb-rate-label">{{ r.labelKey | t }}</span>
      </button>
    </div>
  </div>

  <!-- Step 2: details -->
  <div class="afb-body afb-step" *ngIf="step === 'details'">
    <button type="button" class="afb-back" (click)="back()">
      <i class="pi pi-arrow-left"></i>{{ 'appFeedback.back' | t }}
      <span class="afb-picked">{{ selectedEmoji }}</span>
    </button>

    <div class="afb-section-label">
      <i class="pi pi-comment"></i>{{ (isPositive ? 'appFeedback.likeLabel' : 'appFeedback.improveLabel') | t }}
    </div>
    <textarea pTextarea class="w-full afb-textarea" rows="3" maxlength="4000" [(ngModel)]="text"></textarea>
    <p class="afb-hint" *ngIf="!isPositive"><i class="pi pi-lock"></i>{{ 'appFeedback.privateNote' | t }}</p>

    <ng-container *ngIf="isPositive">
      <div class="afb-section-label afb-section-gap"><i class="pi pi-globe"></i>{{ 'appFeedback.showSection' | t }}</div>

      <div class="afb-toggle-row">
        <p-toggleswitch inputId="afbShowName" [(ngModel)]="showName" (ngModelChange)="onShowNameChange($event)"></p-toggleswitch>
        <label for="afbShowName" class="afb-toggle-label">
          <span>{{ 'appFeedback.showName' | t }}</span>
          <span class="afb-toggle-hint">{{ 'appFeedback.showNameHint' | t }}</span>
        </label>
      </div>

      <div class="afb-toggle-row" [class.afb-toggle-row--disabled]="!showName">
        <p-toggleswitch inputId="afbShowCompany" [(ngModel)]="showCompany" [disabled]="!showName"></p-toggleswitch>
        <label for="afbShowCompany" class="afb-toggle-label">
          <span>{{ 'appFeedback.showCompany' | t }}</span>
          <span class="afb-toggle-hint">{{ 'appFeedback.showCompanyHint' | t }}</span>
        </label>
      </div>
    </ng-container>

    <p class="afb-error" *ngIf="error"><i class="pi pi-exclamation-circle"></i>{{ 'appFeedback.error' | t }}</p>

    <div class="afb-actions">
      <button pButton type="button" icon="pi pi-send" class="w-full"
        [label]="'appFeedback.send' | t"
        [loading]="sending"
        [disabled]="sending || !networkStatusService.isOnline"
        [pTooltip]="!networkStatusService.isOnline ? ('offline.unavailableTitle' | t) : ''" tooltipPosition="top"
        (click)="send()"></button>
    </div>
  </div>

  <!-- Step 3: thank you (concentric-rings graphic, same idiom as the list empty state) -->
  <div class="afb-body afb-thanks afb-step" *ngIf="step === 'thanks'">
    <div class="afb-rings">
      <span class="afb-ring afb-ring--3"></span>
      <span class="afb-ring afb-ring--2"></span>
      <span class="afb-ring afb-ring--1"></span>
      <i class="pi pi-check afb-rings-icon"></i>
    </div>
    <h3 class="afb-thanks-title">{{ 'appFeedback.thanksTitle' | t }}</h3>
    <p class="afb-thanks-body">{{ 'appFeedback.thanksBody' | t }}</p>
    <button pButton type="button" [label]="'appFeedback.done' | t" class="p-button-outlined" (click)="close()"></button>
  </div>
</p-dialog>

<!-- ══ Dashboard prompt card — only when enabled by SUPER_ADMIN/ROOT ══ -->
<div class="afb-prompt" *ngIf="promptVisible" role="dialog" aria-live="polite">
  <button type="button" class="afb-prompt-close" (click)="dismissPrompt()" aria-label="Close">
    <i class="pi pi-times"></i>
  </button>
  <div class="afb-prompt-head">
    <div class="afb-logo-badge afb-logo-badge--sm"><i class="pi pi-star"></i></div>
    <div>
      <p class="afb-prompt-title">{{ 'appFeedback.promptTitle' | t }}</p>
      <p class="afb-prompt-body">{{ 'appFeedback.promptBody' | t }}</p>
    </div>
  </div>
  <div class="afb-prompt-emojis">
    <button type="button" class="afb-prompt-emoji" *ngFor="let r of ratings"
      [pTooltip]="r.labelKey | t" tooltipPosition="top" (click)="pickFromPrompt(r.value)">{{ r.emoji }}</button>
  </div>
  <button type="button" class="afb-prompt-later" (click)="dismissPrompt()">{{ 'appFeedback.notNow' | t }}</button>
</div>
